import { BOM } from './BOM.js';
import { track } from './TrackerWrapper.js';
import { PHONETYPE, APPID } from './config';
import {
    openUrl,
    clientLogin,
    configShareButton,
    showShareView,
    closeWebview,
    trackServer,
    trackUmeng,
    writeKeyChain
} from './client.js';

let CACHE = {
    lang: null,
    urlParams: null,
    env: null,
    urlParamsString: null,
    deviceType: -1, //1 ios
    pokeUser: null,
    protocol: null,
    loginSatus: -1,
    iphoneX: -1, //1 iphonex
    h5Params: null,
    h5ParamsDict: null
};

function redirect(url) {
    BOM.window.location.href = url || 'https://www.pokekara.com/download';
}

//
function format(param, replace = true) {
    if (typeof param == 'undefined') {
        return '';
    }
    if (typeof param != 'object') {
        throw new Error('data sended to the server must be \'object\'');
    }
    let s = [];
    for (let j in param) {
        s.push(encodeURIComponent(j) + '=' + encodeURIComponent(param[j]));
    }
    if (replace) {
        return s.join('&').replace(/%20/g, '+');
    } else {
        return s.join('&');
    }
}

const jsonField = ['extra_data', 'list', 'dm_info', 'extra', 'calendar'];

function deFormat(param, num_type) {
    let p = {};
    let temp = param.split('&');
    for (let i = 0, l = temp.length; i < l; i++) {
        let t = temp[i].split('=');
        if (jsonField.indexOf(t[0]) != -1) {
            p[t[0]] = JSON.parse(decodeURIComponent(t[1]));
        } else {
            let num = parseFloat(t[1]);
            //10 作为临界定，为大整数，应该传str
            if (isNaN(num) || t[1].length > 10) {
                p[t[0]] = decodeURIComponent(t[1]);
            } else {
                if (num_type) {
                    p[t[0]] = t[1];
                } else {
                    p[t[0]] = num;
                }
            }
        }
    }
    return p;
}

//控制字符长度
function countChars(s, len, flag) {
    let str = new String(s);
    let strLen = str.replace(/[\uFE30-\uFFA0\u2E80-\u9FFF\u3000\uac00-\ud7ff‘“”’]/g, '**').length,
        newStr = [],
        totalCount = 0;
    if (strLen <= len) {
        return str;
    } else {
        for (let i = 0; i < strLen; i++) {
            let nowValue = str.charAt(i);
            // eslint-disable-next-line no-control-regex
            if (/[^\x00-\xff]/.test(nowValue)) {
                totalCount += 2;
            } else {
                totalCount += 1;
            }
            newStr.push(nowValue);
            if (totalCount >= len) {
                break;
            }
        }
        if (flag) {
            return newStr.join('');
        } else {
            return newStr.join('') + '...';
        }
    }
}

//取得网页query 参数
function getUrlStrs(href) {
    let queryString="";
    if(href){
        const urls=href.split("?");
        queryString=urls[1]?"?"+urls[1]:'';
    }else {
        if (CACHE.urlParams) return CACHE.urlParams;
        queryString= window.location.search;
    }
    const data = {}, reg = new RegExp('([^?=&]+)(=([^&]*))?', 'g');
    queryString.replace(reg, function($0, $1, $2, $3) {
        data[$1] = $3;
    });
    if(!href) {
        CACHE.urlParams = data;
    }
    return data;
}

function getUniversalParameters() {
    if (CACHE.urlParamsString) return CACHE.urlParamsString;
    let querystring = /.+(\?.+)/.exec(window.location.href);
    if (querystring) {
        querystring = querystring[1];
    } else {
        querystring = '';
    }
    CACHE.urlParamsString = querystring;
    return querystring;
}

function getCookie(c_name) {
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + '=');
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            let c_end = document.cookie.indexOf(';', c_start);
            if (c_end == -1) c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return '';
}

function setCookie(name, value, days) {
    let Days = days || 30;
    let exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
}

//取得当前用户信息
//http://wiki.maetime.com/pages/viewpage.action?pageId=14899143 iOS WebView 上下文设置
function getPokeUser() {
    if (CACHE.pokeUser) return CACHE.pokeUser;
    try {
        const pokeUser =
            BOM.document.pokeUser ||
            (BOM.document.pokeUser =
                (BOM.window.androidObj &&
                    BOM.window.androidObj.pokeUser &&
                    JSON.parse(BOM.window.androidObj.pokeUser())) ||
                {});
        CACHE.pokeUser = pokeUser;
        return pokeUser;
    } catch (e) {
        return {};
    }
}

//清除pokeUser 缓存
function clearPokeUserCache() {
    CACHE.pokeUser = null;
}

//dom 元素位置
function getPosition(node) {
    let posx = 0,
        posy = 0;
    while (node.offsetParent) {
        posy = posy + node.offsetTop;
        posx = posx + node.offsetLeft;
        node = node.offsetParent;
    }
    return {
        x: posx,
        y: posy
    };
}

function isIos() {
    if (CACHE.deviceType != -1) {
        return CACHE.deviceType;
    }
    if (!navigator) {
        return false;
    }
    if (!navigator.userAgent) {
        return false;
    }
    const is = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    CACHE.deviceType = is;
    return is;
}

//1 =>01
function toTwoDigit(num) {
    return num < 10 ? '0' + num : num;
}

//日期格式化  yyyy年MM月dd日 => 2022年04月14日
function formatDate(time, formation) {
    let date = new Date(time);
    let _temp_year = date.getFullYear();
    let _temp_month = date.getMonth() + 1;
    let _temp_date = date.getDate();
    let _temp_hour = date.getHours();
    let _temp_minute = date.getMinutes();
    let _temp_second = date.getSeconds();

    function _get_date_part(part) {
        switch (part) {
        case 'yyyy':
            return _temp_year;
        case 'yy':
            return _temp_year.toString().slice(-2);
        case 'MM':
            return toTwoDigit(_temp_month);
        case 'M':
            return _temp_month;
        case 'dd':
            return toTwoDigit(_temp_date);
        case 'd':
            return _temp_date;
        case 'HH':
            return toTwoDigit(_temp_hour);
        case 'H':
            return _temp_hour;
        case 'hh':
            return toTwoDigit(_temp_hour > 12 ? _temp_hour - 12 : _temp_hour);
        case 'h':
            return _temp_hour > 12 ? _temp_hour - 12 : _temp_hour;
        case 'mm':
            return toTwoDigit(_temp_minute);
        case 'm':
            return _temp_minute;
        case 'ss':
            return toTwoDigit(_temp_second);
        case 's':
            return _temp_second;
        default:
            return part;
        }
    }

    return formation.replace(/y+|m+|d+|h+|s+|H+|M+/g, _get_date_part);
}

//取得静态分页数据
function getStaticData(store, page, page_size) {
    let length = store.length;
    let _page_size = page_size || 10;
    let start = page * _page_size,
        end = (page + 1) * _page_size;
    end = Math.min(end, length);
    start = Math.min(start, length);
    return {
        data: store.slice(start, end),
        has_more: end != length
    };
}

//翻译 "hell%s wo%sld 1%d3" ["o","r",2]  => hello world 123
function translate(str, replace_ary) {
    let reg = str.match(/%s|%d/g);
    if (reg) {
        for (let i = 0; i < reg.length; i++) {
            str = str.replace(reg[i], replace_ary[i]);
        }
    }
    return str;
}

function getDeviceSniffSize() {
    let ratio = window.devicePixelRatio || 1;
    return {
        width: window.screen.width * ratio,
        height: window.screen.height * ratio
    };
}

//是否小屏幕
function isScreenLimited(params) {
    try {
        if (params) {
            const h = parseInt(params.screen_height);
            return isIos() ? h <= 480 : h <= 1184;
        } else {
            return isIos() ? BOM.window.screen.height <= 480 : BOM.window.screen.height <= 640;
        }
    } catch (e) {
        return false;
    }
}

//是否iphonex 以及以上
function isIphoneX() {
    if (CACHE.iphoneX != -1) {
        return CACHE.iphoneX;
    }
    let ratio = window.devicePixelRatio || 1;
    let screen = {
        width: window.screen.width * ratio,
        height: window.screen.height * ratio
    };
    //iphone11 2x
    const is =
        /iphone/gi.test(navigator.userAgent) && (screen.height >= 2436 || screen.height === 1792);
    CACHE.iphoneX = is;
    return is;
}

//取得app版本，用于版本比较
function getAppVersion(v) {
    const _v = v || '.';
    const _varray = _v.split('.');
    const l = _varray.length;
    if (l <= 1 || l > 4) {
        return 1000000;
    }
    if (l === 2) {
        _varray.push('0', '0');
    } else if (l === 3) {
        _varray.push('0');
    }
    return +_varray[0] * 1000000 + +_varray[1] * 10000 + +_varray[2] * 100 + +_varray[3];
}

//当前环境:测试 | 线上
function getEnv() {
    if (CACHE.env) return CACHE.env;
    let _htmlNode = document.getElementsByTagName('html')[0];
    let _env = _htmlNode.getAttribute('env');
    if (_env) {
        CACHE.env = _env;
    }
    return CACHE.env || 'cdn';
}

//
function getLang() {
    if (CACHE.lang) return CACHE.lang;
    let _htmlNode = document.getElementsByTagName('html')[0];
    let _lang = _htmlNode.getAttribute('lang');
    if (_lang) {
        CACHE.lang = _lang;
    }
    return CACHE.lang || 'ja';
}

//android 版本universial link
function openAndriod(openurl, label) {
    const re = new RegExp('universal/(.+)', 'g');
    let _openurl;
    const result = re.exec(openurl);
    if (result) {
        _openurl = result[1];
    } else {
        _openurl = 'root?tab=sing';
    }
    if (label && typeof label === 'string') {
        track(label);
    }
    window.location.href = 'pokekara://' + _openurl;
    setTimeout(function() {
        window.location.href = openurl;
    }, 2000);
}

function isLogin() {
    try {
        const pokeUser = getPokeUser();
        return pokeUser.uid ? true : false;
    } catch (e) {
        return false;
    }
}

//是否登录
function isUserLogin() {
    if (CACHE.loginSatus != -1) {
        return CACHE.loginSatus;
    }
    if (isLogin()) {
        CACHE.loginSatus = 1;
        return 1;
    }
    const env = getEnv();
    //测试环境不cache了
    if (env != 'cdn' && getUrlStrs().__uid__) {
        return 1;
    }
    CACHE.loginSatus = 0;
    return 0;
}

//版本号判定 v >= targetV
function isVersionMoreThanOrEqualTo(v, targetV) {
    const currentVersion = getAppVersion(v);
    const targetVersion = getAppVersion(targetV);
    if (currentVersion >= targetVersion) {
        return true;
    }
    return false;
}

//线上测试域名切换
function getProtocol(env, isWeb) {
    if (CACHE.protocol) return CACHE.protocol;
    const _isWeb = isWeb || false;
    if (!_isWeb) {
        CACHE.protocol =
            env === 'cdn' ? 'https://api.pokekara.com' : 'http://test.api.pokekara.com';
    } else {
        CACHE.protocol = env === 'cdn' ? 'https://www.pokekara.com' : 'http://test.pokekara.com';
    }
    return CACHE.protocol;
}

function getLabelKey(rank) {
    if (rank > 100) {
        return -1;
    } else if (rank > 50) {
        return 5;
    } else if (rank > 20) {
        return 4;
    } else if (rank > 3) {
        return 3;
    } else if (rank > 2) {
        return 2;
    } else if (rank > 1) {
        return 1;
    } else {
        return 0;
    }
}

//10000 ===> 10k
function kformat(_num, length = 2) {
    let num = _num || 0;
    if (num.length) {
        num = parseInt(num);
    }
    if (num > 1000) {
        if (num % 1000 < 10) {
            return (num / 1000).toFixed(0) + 'k';
        } else {
            return (num / 1000).toFixed(length) + 'k';
        }
    }
    return num;
}

//是否在app内
function isNative() {
    return (
        !!(window.androidObj || (document.pokeUser && Object.keys(document.pokeUser).length > 1)) ||
        getUrlStrs().v
    );
}

//取得下一页
function getNextPageCursor(data = {}) {
    return data.pagination ? data.pagination.next_cursor_str || 0 : data.next_cursor_str || 0;
}

//xss && 保留空格与换行
function formatInput(str) {
    return encodeSpecialHtmlChar(str)
        .replace(/\u0020/g, '&nbsp;')
        .replace(/\n/g, '<br />');
}

function loadMedia(ele, mediaType = 0) {
    let w = mediaType === 0 ? ele.naturalWidth : ele.videoWidth,
        h = mediaType === 0 ? ele.naturalHeight : ele.videoHeight,
        p_w = ele.parentNode.offsetWidth,
        p_h = ele.parentNode.offsetHeight,
        percent = w / h,
        p_percent = p_w / p_h;
    if (percent < p_percent) {
        let w = p_h * percent;
        ele.style.height = p_h ? p_h + 'px' : '100%';
        ele.style.width = w ? w + 'px' : '100%';
    } else {
        let h = p_w / percent;
        ele.style.height = h ? h + 'px' : '100%';
        ele.style.width = p_w ? p_w + 'px' : '100%';
    }
}

const s = 60;
const hour_s = 3600;
const day_s = hour_s * 24;

//秒数 对应的日，时，分，秒
function getGapTime(seconds) {
    if (seconds <= 0) {
        return {
            day: 0,
            hour: 0,
            min: 0,
            sec: 0
        };
    }
    const day = Math.floor(seconds / day_s);
    const hour = Math.floor((seconds % day_s) / hour_s);
    const min = Math.floor((seconds - day_s * day - hour_s * hour) / s);
    const sec = seconds - day_s * day - hour_s * hour - min * s;
    return {
        day,
        hour,
        min,
        sec
    };
}

function getH5ParametersDict() {
    if (CACHE.h5ParamsDict) {
        return CACHE.h5ParamsDict;
    }
    const params = { ...getUrlStrs() };
    !params.appid && (params.appid = APPID);
    !params.phonetype && (params.phonetype = PHONETYPE);
    params.request_refer = 'h5';
    params.request_id && delete params.request_id;
    CACHE.h5ParamsDict = params;
    return CACHE.h5ParamsDict;
}

function getH5Parameters() {
    if (CACHE.h5Params) {
        return CACHE.h5Params;
    }
    const params = getH5ParametersDict();
    CACHE.h5Params = format(params);
    return CACHE.h5Params;
}

function createRequestId() {
    return new Date().getTime().toString() + Math.ceil(Math.random() * 1000).toString();
}

//分享页地址
function getShareUrl(id) {
    let protocol = 'https://u.pokekara.com/';
    if (getEnv() === 'dev') {
        protocol = 'http://test.pokekara.com/';
    }
    return protocol + 'i/' + id;
}

//取得活动页得地址
function getPageUrl(projectName, pageName) {
    let url =
        'https://api.pokekara.com/webkara/static/online/cli/' +
        projectName +
        '/dist/' +
        pageName +
        '.html';
    if (getEnv() === 'dev') {
        url =
            'https://test.api.pokekara.com/webkara/static/dev/cli/' +
            projectName +
            '/dist/' +
            pageName +
            '.html';
    }
    return url;
}

//取得rem font-size
function getFontSize() {
    const htmlStyle = document.getElementsByTagName('html')[0].getAttribute('style');
    if (htmlStyle) {
        const matchArray = htmlStyle.match(/\d+(\.\d+)?/g);
        if (matchArray && !isNaN(matchArray[0])) {
            return matchArray[0];
        }
    }
    return 0;
}

function getDpr() {
    const dpr = document.getElementsByTagName('html')[0].getAttribute('data-dpr');
    return parseInt(dpr);
}

function insertBr(str, length) {
    const size = Math.ceil(str.length / length);
    const temp = Array.from(new Array(size).keys());
    temp.shift();
    let pool = temp.map(v => {
        return v * length - 1;
    });
    let final = [];
    for (let i = 0; i < str.length; i++) {
        final.push(str[i]);
        if (pool.indexOf(i) != -1) {
            final.push('<br>');
        }
    }
    return final.join('');
}

function setTitle(title) {
    BOM.document.getElementsByTagName('title')[0].innerText = title;
}

const regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/gi;

function getTextLength(str) {
    return str.replace(regStr, '*').length;
}

//取得 固定rem尺寸的实际px大小
function getSize(num) {
    const fontSize = getFontSize();
    return (num * fontSize) / 100;
}

//纵向滚动浏览器滚动条，并执行回调
function windowScrollTo(dis, cb) {
    BOM.window.scrollTo({
        top: dis,
        left: 0,
        behavior: 'smooth'
    });
    if (cb) {
        //兼容ios滑动之后焦点丢失的问题
        let t;
        const running = e => {
            t && clearTimeout(t);
            t = setTimeout(() => {
                cb();
                BOM.window.removeEventListener('scroll', running);
            }, 100);
        };
        BOM.window.addEventListener('scroll', running, false);
    }
}

//处理xss
function encodeSpecialHtmlChar(str) {
    if (str) {
        let codingchar = [
            '&',
            '<',
            '>',
            '"',
            '\'',
            'onclick',
            'onfocus',
            'onmouseover',
            'onmouseout',
            'script',
            'iframe'
        ];
        let sepchar = ['&amp;', '&lt;', '&gt;', '&quot;', '&apos;', '', '', '', '', '', ''];
        let len = sepchar.length;

        for (let i = 0; i < len; i++) {
            str = str.replace(new RegExp(codingchar[i], 'ig'), sepchar[i]);
        }
        return str;
    } else {
        return '';
    }
}

//取得字符串长度（一个日文两个字符）
function getCharSize(str) {
    return str.replace(/[\uFE30-\uFFA0\u2E80-\u9FFF\u3000\uac00-\ud7ff‘“”’]/g, '**').length;
}

/*
*校验日本身份证号：12位数字
*用于输入实时验证
 */
function filterIdCardNumber(val) {
    return val.replace(/[^\d]/g, '').substr(0, 12);
}

/*
* 取得url param参数
* 例
* https://u.pokekara.com/mv/234555 ===> 234555
* */
function getUrlParams(url) {
    let pathname = window.location.pathname;
    if (url) {
        const urlStr = url.split('?')[0];
        const index = urlStr.indexOf('/');
        pathname = urlStr.slice(index, urlStr.length);
    }
    const index = pathname.lastIndexOf('/');
    if (index != -1) {
        return pathname.slice(index + 1, pathname.length);
    } else {
        return '';
    }
}

//是否移动端
function isMobile(agent) {
    const _agent = agent || BOM.window.navigator.userAgent;
    return /(iPhone|iPad|iPod|iOS|android|BlackBerry|hp-tablet|Symbian|Windows Phone)/i.test(
        _agent
    );
}

//是否需要border 1像素处理(安卓小屏幕bug)
function needBorderFix() {
    const size = getFontSize();
    return size < 50;
}

//整除
function mod(num, unit = 10) {
    return Math.floor(num / unit);
}

//计算年龄
function calculatAge(y, m, d) {
    const now = new Date();
    const _y = now.getFullYear() - y;
    const _m = now.getMonth() + 1 - m;
    const _day = now.getDate() - d;
    if (_m > 0) {
        return _y;
    } else if (_m === 0) {
        if (_day >= 0) {
            return _y;
        } else {
            return _y - 1;
        }
    } else {
        return _y - 1;
    }
}

function getUrlQueryParams(url) {
    const data = {};
    const search = url.split('?')[1];
    if (search) {
        const _url = '?' + search;
        const reg = new RegExp('([^?=&]+)(=([^&]*))?', 'g');
        _url.replace(reg, function($0, $1, $2, $3) {
            data[$1] = $3;
        });
    }
    return data;
}

export {
    format,
    countChars,
    getUrlStrs,
    getUniversalParameters,
    getCookie,
    setCookie,
    getPokeUser,
    getPosition,
    isIos,
    toTwoDigit,
    formatDate,
    clientLogin,
    configShareButton,
    showShareView,
    openUrl,
    closeWebview,
    getStaticData,
    translate,
    getDeviceSniffSize,
    isScreenLimited,
    isIphoneX,
    getAppVersion,
    trackServer,
    trackUmeng,
    getEnv,
    getLang,
    openAndriod,
    isUserLogin,
    isVersionMoreThanOrEqualTo,
    getProtocol,
    writeKeyChain,
    getLabelKey,
    kformat,
    isNative,
    getNextPageCursor,
    formatInput,
    loadMedia,
    getGapTime,
    clearPokeUserCache,
    redirect,
    getH5Parameters,
    createRequestId,
    getShareUrl,
    getPageUrl,
    getFontSize,
    getDpr,
    insertBr,
    setTitle,
    getTextLength,
    getSize,
    windowScrollTo,
    deFormat,
    encodeSpecialHtmlChar,
    getCharSize,
    getH5ParametersDict,
    filterIdCardNumber,
    getUrlParams,
    isMobile,
    needBorderFix,
    mod,
    calculatAge,
    getUrlQueryParams
};
